import styled from "styled-components";

export const ProjectVersionContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  position: absolute;
  right: 20px;
  @media (max-width: 1170px) {
    display: none;
  }
`;
const ProjectVersionText = styled.p`
  font-size: 14px;
  color: #808080;
`;

const ProjectVersion = () => (
  <ProjectVersionContainer>
    <ProjectVersionText>Version 4.0.0</ProjectVersionText>
  </ProjectVersionContainer>
);

export default ProjectVersion;
